<app-modal
  [title]="'Choose Customer'| trans:'customer-search-modal/header/title'"
  maxWidth="1000px"
>
  <ng-template>
    <div class="d-flex gap-8 flex-grow-1 flex-direction-column">
      <app-search (searchChange)="searchVal = $event; handleCustomersSearchChange();" />

      @if (isLoading()) {
        <div class="d-flex justify-content-center full-height align-items-center">
          <app-loader size="lg" />
        </div>
      } @else if (customers) {
        @if (customers.length > 0) {
          <table class="base full-width table-layout-fixed">
            <thead>
              <tr>
                <th width="20%">
                  {{ 'Name' | trans:'customer-search-modal/table/fullName.Text' }}
                </th>
                <th width="20%">
                  {{ 'Customer number' | trans:'customer-search-modal/table/customerNumber.Text' }}
                </th>
                <th width="40%">
                  {{ 'Email' | trans:'customer-search-modal/table/email.Text' }}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (c of customers; track c.id) {
                <tr
                  class="selectable-tr cursor-pointer"
                  [class.selected]="selectedCustomer?.id === c.id"
                  #trEl
                  (click)="selectCustomerRow(c, trEl)"
                >
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ c.firstName }} {{ c.lastName }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ c.customerNumber }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ c.email }}
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center justify-content-flex-end">
                      <button
                        class="button button--icon-sm button--no-border c-t-blue-700"
                        (click)="$event.stopPropagation(); editCustomerModalComponent.open(c); selectedCustomer = c; toggleRow(trEl, true);"
                      >
                        <i class="ri-pencil-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>

                <tr class="d-none subrow">
                  <td colspan="4" class="p-b-32">
                    <table class="base-sm full-width table-layout-fixed">
                      <thead>
                      <tr>
                        <th width="20%">
                          {{ 'Company name'| trans:'customer-search-modal/table/companyName.Text' }}
                        </th>
                        <th width="80%">
                          {{ 'Address'| trans:'customer-search-modal/table/address.Text' }}
                        </th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr>
                        <td>
                          <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                            {{ c.companyName }}
                          </div>
                        </td>
                        <td>
                          <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                            @if (c.street || c.postalCode || c.city || c.countryName) {
                              @if (c.street && c.postalCode && c.city) {
                                {{ c.street }}, {{ c.postalCode }} {{ c.city }}
                              }{{ c.countryName }}
                            }
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p>{{ 'No customers found.' | trans:'customer-search-modal/noCustomersFound.Text' }}</p>
        }
      }
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-space-between">
      <div class="d-flex gap-16">
        <button
          class="button button--md button--primary text-uppercase"
          (click)="addCustomerModalComponent.open()"
        >
          {{ 'Add customer'| trans:'customer-search-modal/addCustomer.Button' }}
        </button>

        @if (showAnonymButton) {
          <button
            class="button button--md button--primary-ghost text-uppercase"
            (click)="confirmCustomerSelection.emit({ isAnonym: true }); close();"
          >
            {{ 'Anonym'| trans:'customer-search-modal/anonym.Button' }}
          </button>
        }
      </div>

      <div class="d-flex gap-16">
        <button
          class="button button--md button--primary-ghost text-uppercase"
          (click)="dismissed.emit(); close()"
        >
          {{ 'Close'| trans:'customer-search-modal/close.Button' }}
        </button>

        @if (!openDetailsOnRowClick) {
          <button
            class="button button--md button--primary text-uppercase"
            [disabled]="!selectedCustomer"
            (click)="confirmCustomerSelection.emit(selectedCustomer); close();"
          >
            {{ 'Confirm'| trans:'customer-search-modal/confirm.Button' }}
          </button>
        }
      </div>
    </div>
  </ng-container>
</app-modal>

<app-add-customer-modal
  #addCustomerModalComponent
  (formFinished)="selectedCustomer = { id: $event }; confirmCustomerSelection.emit(selectedCustomer); close();"
/>

<app-edit-customer-modal
  #editCustomerModalComponent
  (formFinished)="updateCustomerInList($event)"
/>
